import React from 'react'
import PropTypes from 'prop-types'
import { Form, Input } from 'antd'

import css from './styles.css'

const BrandName = ({ brandName, onChange }) => (
  <div>
    <span>
      If you would like to display a different practice name on the widget
      header, indicate that name here:
    </span>
    <div className={css.extraQuestionContainer}>
      <Form.Item
        key="brandName"
        className={css.extraQuestionField}
      >
        <Input
          name={brandName}
          onChange={e => onChange(e)}
          value={brandName}
        />
      </Form.Item>
    </div>
  </div>
)

BrandName.propTypes = {
  brandName: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
}

export default BrandName



// WEBPACK FOOTER //
// ./src/AddPractice/Info/SchedulingWidgetSnippet/BrandName.js